import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
import NewEventPopup from './NewEventPopup';
import DashboardHeading from '../commonFiles/DashboardHeading';

class ViewEvents extends Component {
  constructor() {
    super();
    this.state = {
      all_table_row:[],
      addNewEventPopup:'',
    };
  }

formatTime(timeString) {
    const [hourString, minute] = timeString.split(":");
    const hour = +hourString % 24;
    return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
}

show_list(list){
  var all_table_row = [];
  if(list.length>0){
    var no =1;
    for(var i=0; i<list.length; i++){
    var list_data = list[i];
    var info      = list_data['data'];
    var dwonload_icon = '';
    if(info['new_agenda_file_name']!=''){ dwonload_icon = <a class="pointer"><i class="fas fa-file-download"></i></a>;}
      all_table_row.push(<tr>
        <td>{no}</td>
        <td>{info['event_title']}</td>
        <td>{info['email_list'][0]+'...'}</td>
        <td>{info['envet_from_date']+" "+this.formatTime(info['envet_from_time'])}</td>
        <td>{info['envet_to_date']+" "+this.formatTime(info['envet_to_time'])}</td>
        <td>{info['envet_message'].substring(0, 20)+'...'}</td>
        <td>{dwonload_icon}</td>
        <td></td>
        </tr>);
        no++;
    }
  }else{
    all_table_row.push(<tr><td colspan="8">No Event</td></tr>);
  }
  this.setState({all_table_row});
}

get_all_event_list(){
  var cutThis        = this;
  var web_token     = window.isNullAndUndef($('#web_token').val());
  var body          = new FormData();
  body.append('web_token',web_token);
  body.append('function','get_all_event_data');
  var url      = '';
  if(window.location.host ==="localhost:3000"){
    url = "http://localhost/bylawsindia/php/admin_event_manage_url.php";
  }else{
    url = "/php/admin_event_manage_url.php";
  }
  axios({
       method: 'POST',
       url: url,
       async: false,
       data: body,
       enctype: 'multipart/form-data',
       processData: false,
       contentType: false,
       cache: false,
   })
   .then(function (res) {
      var data = res.data;
      cutThis.show_list(data);
   })
   .catch(function (error) {
       console.log(error);
   });
}


componentDidMount(){
  this.get_all_event_list();
}

schedule_consultation(){
  var addNewEventPopup = <NewEventPopup close_popup_view={this.close_popup.bind(this)}/>;
  this.setState({addNewEventPopup});
  setTimeout(function (){window.model_show();},100);
}

close_popup(){
  window.model_hide();
  var addNewEventPopup = '';
  this.setState({addNewEventPopup});
  this.get_all_event_list();
}

  render() {
    return (
        <>
        <DashboardHeading title="Event Management"/>
        	<div className="container mt-4 mb-4 Dashboard_main_div">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">Event Management</h3>


                <div className="col-md-12 p-0">
                <div className="col-md-3 p-0 float_r">
                      <button className="btn btn-primary w-100 py-3" type="button" onClick={this.schedule_consultation.bind(this)}>New Event</button>
                </div>

                <table class="table">
                <thead>
                <tr>
                <th scope="col">#</th>
                <th scope="col">Title</th>
                <th scope="col">Attendees</th>
                <th scope="col">From Date</th>
                <th scope="col">To Date</th>
                <th scope="col">Message</th>
                <th scope="col">Agenda</th>
                <th scope="col">Action</th>
                </tr>
                </thead>
                <tbody>
                {this.state.all_table_row}
                </tbody>
                </table>

            </div>
            {this.state.addNewEventPopup}
        </div>
        </>
    );
  }
}

export default ViewEvents;
